import { InjectedFormProps, reduxForm } from 'redux-form';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { CancellationReason } from '@mews-commander/data-access';
import { Stack } from '@optimus-web/core';
import {
    presence,
    EnumSelectField,
    EditDialogForm,
    InputField,
    useFormValueSelector,
    validation,
} from '@mews-commander/legacy-form';

const CANCEL_FORM_NAME = 'CancelAvailablityBlockForm';

export interface CancelFormValues {
    cancellationReason: CancellationReason;
    cancellationReasonDetail: string | null;
}

interface CancelAvailabilityBlockDialogProps {
    onSubmit: (values: CancelFormValues) => Promise<unknown>;
    onClose: () => void;
    initialValues?: Partial<CancelFormValues>;
}

type CombinedProps = CancelAvailabilityBlockDialogProps &
    InjectedFormProps<CancelFormValues, CancelAvailabilityBlockDialogProps>;

const CancelAvailabilityBlockDialog: React.FC<CombinedProps> = ({ onClose, onSubmit, handleSubmit, submitting }) => {
    const selectedReason = useFormValueSelector<CancelFormValues>(CANCEL_FORM_NAME, 'cancellationReason');

    return (
        <EditDialogForm
            active
            loading={submitting}
            primaryButtonTextKey={TextKey.Cancel}
            title={<LocalizedText textKey={TextKey.CancelAvailabilityBlockDialogTitle} />}
            closeDialog={onClose}
            handleSubmit={handleSubmit(onSubmit)}
        >
            <Stack vertical spacing="200">
                <EnumSelectField
                    required
                    enumClass={CancellationReason}
                    enumPrefix="CancellationReason"
                    name="cancellationReason"
                    label={<LocalizedText textKey={TextKey.Reason} />}
                />
                <InputField
                    required={selectedReason === CancellationReason.Other}
                    name="cancellationReasonDetail"
                    label={<LocalizedText textKey={TextKey.DetailPlural} />}
                />
            </Stack>
        </EditDialogForm>
    );
};

const getConstraints = (_: unknown, values: CancelFormValues) => ({
    cancellationReason: { presence },
    cancellationReasonDetail: values.cancellationReason === CancellationReason.Other ? { presence } : {},
});

export default reduxForm<CancelFormValues, CancelAvailabilityBlockDialogProps>({
    form: CANCEL_FORM_NAME,
    validate: validation(getConstraints),
})(CancelAvailabilityBlockDialog);
